<div class="agency-branding__preview">
  <article class="agency-branding__page" [style]="previewStyleSig()">
    <header class="agency-branding__page-header">
      <h2 class="agency-branding__page-bulletin">{{ previewTitle }}</h2>
      @if (previewLogoSig(); as previewLogo) {
        <ag-shr-image-with-loader
          class="agency-branding__page-logo"
          [wasabiPath]="previewLogo"
          [cropperPayload]="logoCropperPayloadSig()"
          [mediaSize]="MediaSize.origin"
          [withBorder]="false"
          [usePlaceholder]="false"
        ></ag-shr-image-with-loader>
      }
    </header>

    <div class="agency-branding__page-content">
      <div class="agency-branding__page-title-row">
        <h3 class="agency-branding__page-title">{{ previewSubtitle }}</h3>
        <span class="agency-branding__page-title-line" aria-hidden="true"></span>
        <span class="agency-branding__page-title-icon" aria-hidden="true"></span>
      </div>

      <p class="agency-branding__page-period">{{ previewPeriod }}</p>

      <table class="agency-branding__page-table">
        <thead>
        <tr>
          <th>MGA</th>
          <th class="agency-branding__page-table-numeric">PREMIUM</th>
          <th class="agency-branding__page-table-numeric">COUNT</th>
        </tr>
        </thead>
        <tbody>
          @for (row of previewRows; track row.name) {
            <tr>
              <td>{{ row.name }}</td>
              <td class="agency-branding__page-table-numeric">{{ row.premium | currency: 'USD' : 'symbol' : '1.2-2' }}
              </td>
              <td class="agency-branding__page-table-numeric">{{ row.count | number: '1.1-1' }}</td>
            </tr>
          }
        </tbody>
        <tfoot>
        <tr>
          <td>
            <strong>{{ previewTotals.name }}</strong>
          </td>
          <td class="agency-branding__page-table-numeric">
            <strong>{{ previewTotals.premium | currency: "USD" : "symbol" : "1.2-2" }}</strong>
          </td>
          <td class="agency-branding__page-table-numeric">
            <strong>{{ previewTotals.count | number: '1.1-1' }}</strong>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>

    <footer class="agency-branding__page-footer">
      <span>Generated: {{ generatedAtLabel }}</span>
      <span>Page 1 of 1</span>
    </footer>
  </article>
</div>

<div class="agency-branding__editor" [style]="previewStyleSig()">
  <dx-toolbar class="agency-branding__toolbar">
    <dxi-item location="before">
      <div *dxTemplate>
        <h3 class="agency-branding__title">{{ agency()[AgencyKeys.name] }} branding</h3>
      </div>
    </dxi-item>
    @if (canEditSig()) {
      <dxi-item location="after" [visible]="!inEditModeSig()">
        <div *dxTemplate>
          <dx-button hint="ENABLE EDIT" icon="edit" stylingMode="text" (onClick)="onEdit()"></dx-button>
        </div>
      </dxi-item>
      <dxi-item location="after" [visible]="inEditModeSig()">
        <div *dxTemplate>
          <dx-button
            hint="CANCEL EDIT"
            icon="undo"
            type="danger"
            stylingMode="text"
            (onClick)="onRevert()"
          ></dx-button>
        </div>
      </dxi-item>
      <dxi-item location="after" [visible]="inEditModeSig()">
        <div *dxTemplate>
          <dx-button hint="SAVE" icon="save" stylingMode="text" (onClick)="onSave()"></dx-button>
        </div>
      </dxi-item>
    }
  </dx-toolbar>

  @if (inEditModeSig()) {
    <div class="agency-branding__controls">
      <dx-scroll-view height="100%" [useNative]="false" [showScrollbar]="'always'">
        <div class="agency-branding__controls-body">
          @for (field of colorFields; track field.key) {
            <div class="agency-branding__field">
              <ag-shr-color-sketch-input
                [label]="field.label"
                [value]="displayBrandingSig()[field.key]"
                (valueChange)="onColorChange(field.key, $event)"
              ></ag-shr-color-sketch-input>
              <p class="agency-branding__hint">{{ field.hint }}</p>
            </div>
          }

          <div class="agency-branding__field">
            <span class="agency-branding__field-label">Logo</span>
            <div class="agency-branding__logo-container">
              @let previewLogo = previewLogoSig();
              <ag-shr-image-with-loader
                [class]="'agency-branding__logo-image' + (previewLogo ? '' : ' agency-branding__logo-image--empty')"
                [wasabiPath]="previewLogo"
                [cropperPayload]="logoCropperPayloadSig()"
                [mediaSize]="MediaSize.origin"
                [withBorder]="false"
                [usePlaceholder]="false"
              ></ag-shr-image-with-loader>

              <dx-drop-down-button
                class="agency-campaign-picture__button"
                [showArrowIcon]="false"
                [dropDownOptions]="{ width: 230 }"
                [useItemTextAsTitle]="false"
                icon="edit"
                stylingMode="text"
                [items]="[
                  {
                    icon: 'mdi mdi-upload',
                    text: 'Add Picture',
                    onClick: onUploadClicked,
                    visible: canCreateSig(),
                  },
                  {
                    icon: 'mdi mdi-pencil',
                    text: 'Edit Branding Logo',
                    onClick: handleCropImage,
                    visible: !!previewLogo,
                    disabled: !canEditSig(),
                  },
                ]"
              ></dx-drop-down-button>
            </div>
            <p class="agency-branding__hint">
              Upload a logo, then crop it.
            </p>
          </div>
        </div>
      </dx-scroll-view>

      <ag-shr-media-uploader-modal
        [mediaPathPrefix]="mediaPathPrefixSig()"
        [mediaItems]="agencyMediaDataSource$ | async"
        [waitForProcessing]="true"
        (mediaChanged)="onMediaChanged($event)"
      ></ag-shr-media-uploader-modal>

      <ag-shr-image-cropper-modal
        [onImageCropped]="onImageCropped"
        [imageCropperTitle]="'Edit Branding Logo'"
        [roundCropper]="false"
        [maintainAspectRatio]="true"
        [ratio]="logoAspectRatio"
        [containWithinAspectRatio]="true"
        [cropperBackgroundColor]="displayBrandingSig()[AgencyBrandingKeys.bannerColor]"
        [isLoading]="isPreparingLogoCropperSig()"
      ></ag-shr-image-cropper-modal>
    </div>
  } @else {
    <div class="agency-branding__view">
      <dx-scroll-view height="100%" [useNative]="false" [showScrollbar]="'always'">
        <div class="agency-branding__view-body">
          @for (field of colorFields; track field.key) {
            <div class="agency-branding__view-row">
              <div class="agency-branding__view-label">{{ field.label }}:</div>
              <div class="agency-branding__view-value agency-branding__view-color">
                <span
                  class="agency-branding__color-swatch"
                  [style.--value-color]="displayBrandingSig()[field.key]"
                  aria-hidden="true"
                ></span>
                <span>{{ displayBrandingSig()[field.key] }}</span>
              </div>
            </div>
          }

          <div class="agency-branding__view-row agency-branding__view-row--logo">
            <div class="agency-branding__view-label">Logo:</div>
            <div class="agency-branding__view-value">
              @if (previewLogoSig(); as previewLogo) {
                <ag-shr-image-with-loader
                  class="agency-branding__view-logo"
                  [wasabiPath]="previewLogo"
                  [cropperPayload]="logoCropperPayloadSig()"
                  [mediaSize]="MediaSize.origin"
                  [withBorder]="false"
                  [usePlaceholder]="false"
                ></ag-shr-image-with-loader>
              } @else {
                <span class="ag-empty-text">N/A</span>
              }
            </div>
          </div>
        </div>
      </dx-scroll-view>
    </div>
  }
</div>
